const cookieName = document.URL.match('uvic.ca/graduate/') ? 'uvic-gr-favourite' : 'uvic-favourite';

// initFavouriteButtonClick(favouriteCookies, cookieName)

// Get favourites array from cookie
const getFavouriteCookies = () => Cookies.get(cookieName) ? Cookies.get(cookieName).split(',') : []
let favouriteCookies = getFavouriteCookies()
// console.log(favouriteCookies);

// Set text in Saved programs count indicator
const favsBtn = document.querySelector('.favs__btn')
function setFavouritesButton() {
	favsBtn.querySelector('.favs__btn__num').textContent = favouriteCookies.length
	favsBtn.classList.toggle('active', favouriteCookies.length > 0)
}
setFavouritesButton()

// parse URL for program name - used as unique Saved program value
const getProgramId = (url) => url.href.match(/(?:h.+(?:pages|localhost:3000)\/)(.+)(?:\..+)/)[1]

// Get program favorite buttons
const programFavBtns = document.querySelectorAll('.programs__fav')
// Loop thru each one
programFavBtns.forEach((favBtn) => {
	// Get program link
	const programLink = favBtn.closest('.programs--list__item') ? favBtn.closest('.programs--list__item').querySelector('a.programs--list__link') : false
	// Get program ID based on program link or URL
	const programId = programLink ? getProgramId(programLink) : getProgramId(window.location)
	
	// Set initial active state for programs in cookie
	if (favouriteCookies.indexOf(programId) > -1) favBtn.classList.add('programs__fav--active')

	// Set click behavior
	favBtn.addEventListener('click', () => {
		// Get index of current ID in fav array
		const programIndex = favouriteCookies.indexOf(programId)

		// Does the ID appear in the favs array?
		if (programIndex >= 0) {
			// Remove the ID from the favs
			favouriteCookies.splice(programIndex, 1)
			// Remove active class
			favBtn.classList.remove('programs__fav--active')
		} else {
			// Add the ID to the favs
			favouriteCookies.push(programId)
			// add the active class
			favBtn.classList.add('programs__fav--active')
		}
		// Update the cookie
		Cookies.set(cookieName, favouriteCookies.join(','), { expires: 99, secure: true })
		// Update the total counting button
		setFavouritesButton()
	})
})

// Load favourites card into Saved Programs page
const loadFavouritesCards = async (pagesUrl) => {
	// array to hold loaded program content
	let savedPrograms = []

	// Loop thru each program in the favs array
	await Promise.all(favouriteCookies.map(async (programId) => {
		// Get the URL for the program or grad credential
		const programUrl = programId.includes('-cred') ? `/graduate/programs/graduate-programs/credential-pages/${programId}-card.html` : `${pagesUrl}${programId}-card.html`

		// Load the content from the URL
		const response = await fetch(programUrl)
		
		// If the file didn't load successfully, bail
		if (response.status !== 200) {
			return
		}
		
		// Add the loaded html into the array
		savedPrograms.push(await response.text())
	}))

	// console.log(savedPrograms);
	// Find the content area of the page
	const content = document.querySelector('.uv-main__row .uv-content')

	// Write each card to the page
	savedPrograms.forEach((programCard) => {
		content.insertAdjacentHTML('afterbegin', `<div class="row uv-sect"><div class="col-12">${programCard}</div></div>`)
	})

	// Re-stripe and re-do the in-page nav
	sectionStriping()
	inPageNavigation()

	// Find all the program card close buttons
	const programCloseBtns = document.querySelectorAll('.card .btn--close')

	// Program card close button behavior
	programCloseBtns.forEach((closeBtn) => {
		closeBtn.addEventListener('click', (e) => {
			// Get parent section
			const sect = closeBtn.closest('.uv-sect')
			// Get programID
			const programId = closeBtn.dataset.favourite

			// Remove programID from favs array
			favouriteCookies.splice(favouriteCookies.indexOf(programId), 1)

			// Update cookie and button
			Cookies.set(cookieName, favouriteCookies.join(','), { expires: 99, secure: true })
			setFavouritesButton()

			// Remove section
			sect.remove()

			// Re-stripe and re-do the in-page nav
			sectionStriping()
			inPageNavigation()
		})
	})
}

// Self-ID behaviour
// Get the self-id form
const selfIdForm = document.querySelector('#self-id-wizard') || document.querySelector('#grad-self-id-wizard')
// Is there a form?
const hasSelfId = selfIdForm ? true : false
if (hasSelfId) {
	// Is this a grad or undergrad level
	const selfIdLevel = selfIdForm.id.includes('grad') ? 'GR' : 'UG'
	let selfIdCookieName = selfIdLevel === 'UG' ? 'uvic-selfIdWizard' : 'uvic-grad-selfIdWizard'
	// Get all the elements
	const programWizard = document.querySelector('#program-wizard')
	const programDetails = document.querySelector('#program-details')
	const programReset = programDetails.querySelector('#program-reset, #grad-program-reset')
	const tuitionResults = document.querySelector('.js-tuition-result')
	const hasTuition = (tuitionResults == null) ? false : true
	const tuitionTable = ( hasTuition ) ? tuitionResults.querySelector('#feesTable') : null
	const ancillaryTable = ( hasTuition ) ? tuitionResults.querySelector('#ancillaryFeesTable') : null
	const programResults = document.querySelectorAll('.js-self-id-result')
	const resetElements = document.querySelectorAll('.js-tuition-result, .js-self-id-result, .js-content')
	// Get fee disclaimer
	const feesDisclaimer = document.querySelector('#feesDisclaimer')
	// console.log(selfIdLevel);

	// Common functions
	// Function to split URL params or cookie into array
	function parseSelfId(str) {
		if (!str) return
		if (str.substring(0, 1) === '?') str = str.substring(1)
		var arr = str.split('&')
		return arr.map(function(c, i, a){
			return c.split('=')[1]
		})
	}

	// Style the money values with commas
	const moneyStr = (num) => '$' + num.toString().replace(/(\d)(?=(\d{3})+$)/, '$1,')
		
	// Call the API to fill the tuition table
	const fetchTuition = async (level, residency, programId) => {
		// Set some values
		const residencyLabel = residency === 'D' ? 'Domestic' : 'International'
		level = programId === 9 ? 'LW' : level.toUpperCase()
		// Set the URL to load from
		let url = ''
		if (window.location.hostname === 'localhost') {
			if (level === 'GR') {
				url = '/data/tuition-fees-grad.json'
			} else {
				url = residency === 'D' ? '/data/tuition-fees.json' : '/data/tuition-fees-int.json'
			}
		} else {
			if (level === 'GR') {
				url = `/apis/fee/getFees?level=${level}&residency=${residency}&programId=${programId}`
			} else {
				url = `/apis/fee/getGroupedFees?level=${level}&residency=${residency}&programId=${programId}`
			}
		}

		// console.log(url)

		let tuitionURL = document.querySelector('#tuition-link')
		if ( tuitionURL ) {
			let tuitionURLPath = tuitionURL.pathname;
			tuitionURL.href = tuitionURLPath + '?residency=' + residency + '&level=' + level + '&program=' + programId
		}
	
		// fetch the JSON
		const response = await fetch(url)

		// JSON didn't load, bail
		if (response.status !== 200) {
			return
		}

		// Get the fees data
		const feesData = JSON.parse(await response.text())
		// console.log(feesData);

		// Set-up undergrad elements and vars
		if (tuitionTable) tuitionTable.innerHTML = ''
		let tableBody = ''
		let twoTermTotal = 0
		// Set-up non-Tution fees 
		if (ancillaryTable) ancillaryTable.innerHTML = ''
		let ancillaryTableBody = ''
		let ancillaryTwoTermTotal = 0

		// Set-up grad elements and vars
		const estSpan = tuitionResults.querySelector('.tuition-result__total'),
			estTerms = parseFloat(tuitionResults.dataset.terms),
			estYears = Math.ceil(estTerms / 3)
		let estTotal = 0


		if (level === 'UG') {
			if (feesDisclaimer && residency === 'I' ) feesDisclaimer.style.display = 'block'
			else feesDisclaimer.style.display = 'none'
			// Loop thru the feesData
			feesData['tuition'].forEach(({feeDescription, twoTermFee}) => {
				if (twoTermFee) {
					// Update the total
					twoTermTotal += parseFloat(twoTermFee)
					// Add the fee to the table body
					tableBody += `<tr><td>${feeDescription}</td><td style="text-align: right">${moneyStr(twoTermFee)}</td></tr>`
				}
			})

			feesData['ancillary'].forEach(({feeDescription, twoTermFee}) => {
				if (twoTermFee) {
					// update the total
					ancillaryTwoTermTotal += parseFloat(twoTermFee)
					// Add the fee to the table body
					ancillaryTableBody += `<tr><td>${feeDescription}</td><td style="text-align: right">${moneyStr(twoTermFee)}</td></tr>`
				}
			})
		} else {
			feesData.forEach(({oneTermFee, twoTermFee}) => {
				if (oneTermFee) {
					// Get fee estimates
					const estOne = parseFloat(oneTermFee)
					const estTwo = parseFloat(twoTermFee)
					// Add to total based on if they are by term or year
					if (estOne === estTwo) {
						// The fee is annual, add 1 term * number of years to total
						estTotal += estOne * estYears
					} else {
						// The fee is per term, add 1 term * number of terms to total
						estTotal += estOne * estTerms
					}				
				}				
				// console.log(estTotal)
			})
		}


		if (level === 'UG') {
			// Add the table header and body
			if (tuitionTable) {
				tuitionTable.insertAdjacentHTML('afterbegin', `<thead><tr><th>${residencyLabel} tuition fees (2 terms)</th><th style="text-align: right">${moneyStr(twoTermTotal)}</th></tr></thead>`)
				tuitionTable.insertAdjacentHTML('beforeend', `<tbody>${tableBody}</tbody>`)
			}
			if (ancillaryTable) {
				ancillaryTable.insertAdjacentHTML('afterbegin', `<thead><tr><th>${residencyLabel} ancillary fees (2 terms)</th><th style="text-align: right">${moneyStr(ancillaryTwoTermTotal)}</th></tr></thead>`)
				ancillaryTable.insertAdjacentHTML('beforeend', `<tbody>${ancillaryTableBody}</tbody>`)
			}
		} else {
			estSpan.innerHTML = moneyStr(estTotal)
		}

		// Show fees section
		tuitionResults.classList.remove('d-none')

		// Update the sections and in-page nav
		sectionStriping()
		inPageNavigation()
	}
	
	// Program options
	const optionsJson = {
		"residency"  : { 
			"D"   : {
				"UG": "a Canadian",
				"GR": "a Canadian citizen or permanent resident"
			},
			"I"   : {
				"UG": "an international",
				"GR": "an international student"
			}
		},
		"curriculum" : { 
			"BC"  : {
				"text": "high school student or graduate in British Columbia, Canada",
				"group": "hs-dom-bc"
			},
				"AB"  : {
				"text": "high school student or graduate in Alberta, Canada",
				"group": "hs-dom-ab"
			},
				"IB"  : {
				"text": "International Baccalaureate student",
				"group": "hs-int-ib"
			},
				"MB"  : {
				"text": "high school student or graduate in Manitoba, Canada",
				"group": "hs-dom-ma"
			},
				"NB"  : {
				"text": "high school student or graduate in New Brunswick, Canada",
				"group": "hs-dom-nb"
			},
				"NL"  : {
				"text": "high school student or graduate in Newfoundland and Labrador, Canada",
				"group": "hs-dom-nf"
			},
				"NT"  : {
				"text": "high school student or graduate in Northwest Territories, Canada",
				"group": "hs-dom-nwt"
			},
				"NS"  : {
				"text": "high school student or graduate in Nova Scotia, Canada",
				"group": "hs-dom-ns"
			},
				"NU"  : {
				"text": "high school student or graduate in Nunavut, Canada",
				"group": "hs-dom-nv"
			},
				"ON"  : {
				"text": "high school student or graduate in Ontario, Canada",
				"group": "hs-dom-on"
			},
				"PE"  : {
				"text": "high school student or graduate in Prince Edward Island, Canada",
				"group": "hs-dom-pei"
			},
				"QC"  : {
				"text": "high school student or graduate in Québec, Canada",
				"group": "hs-dom-qc"
			},
				"SK"  : {
				"text": "high school student or graduate in Saskatchewan, Canada",
				"group": "hs-dom-sk"
			},
				"YT"  : {
				"text": "high school student or graduate in Yukon, Canada",
				"group": "hs-dom-yk"
			},
				"AM"  : {
				"text": "student or graduate in an American high school (including AP)",
				"group": "hs-int-am"
			},
				"BT"  : {
				"text": "student or graduate in a British (A-levels) secondary school",
				"group": "hs-int-bt"
			},
				"CH"  : {
				"text": "student or graduate in a Chinese high school",
				"group": "hs-int-ch"
			},
				"IN"  : {
				"text": "student or graduate in an Indian high school",
				"group": "hs-int-in"
			},
				"MX"  : {
				"text": "student or graduate in a Mexican high school",
				"group": "hs-int-mx"
			},
				"VN"  : {
				"text": "student or graduate in a Vietnamese high school",
				"group": "hs-int-vn"
			},
				"99"  : {
				"text": "high school student or graduate at an international school",
				"group": "hs-int-other"
			},
				"BCC" : {
				"text": "student transferring from a BC college",
				"group": "tr-dom-bccol"
			},
				"CAT" : {
				"text": "student transferring from a Canadian college of applied arts and technology",
				"group": "tr-dom-ccaat"
			},
				"CIT" : {
				"text": "student transferring from a Canadian institute of technology",
				"group": "tr-dom-cit"
			},
				"CUV" : {
				"text": "student transferring from a Canadian university",
				"group": "tr-dom-uni"
			},
				"CEG" : {
				"text": "student transferring from a CÉGEP",
				"group": "tr-dom-cegep"
			},
				"AC" : {
					"text": "student transferring from an American post-secondary institution",
					"group": "tr-dom-uni"
			},
				"IP"  : {
				"text": "student transferring from an international post-secondary institution"
			}
		}
	}

// Update Jan 2023
// level - Current highschool now uses 'hs-curr-all'
// level - Graduate highschool now uses 'hs-grad-all'
// level -Domestic and international transfer students use 'tr-all'

	// Get the group codes for the selections
	const getGroups = (residency,level, school, curriculum) => {
		// Create groups array
		let groups = ['all']

		if (residency == 'D') {
			groups.push('dom-all') 
		} else if (residency == 'I') {
			groups.push('int-all')
		}

		if (level === 'HS' || level === 'HG') {
			// Code for all highschool levels
			groups.push('hs-all')

			// current and grad high school students are now separate
			if (level === 'HS') {
				groups.push('hs-curr-all');
			} else if (level === 'HG') {
				groups.push('hs-grad-all');
			}

			// Are they domestic or international? Add the code
			if (school === 'HD') {
				groups.push('hs-dom-all')
			} else if (school === 'HI') {
				groups.push('hs-int-all')
			}
		} else if (level === 'TR'){
			// Code for all transfer levels
			// domestic and international now use the same code
			groups.push('tr-all')
			
			if (school == 'TI') {
				groups.push('tr-int-all')
			}
		}
		// Code for the curriculum
		if (optionsJson.curriculum[curriculum].group) groups.push(optionsJson.curriculum[curriculum].group)
		// Return groups array
		return groups
	}

	// Display the program details based off the self-ID selections
	const programDetailsShow = (residency, level, school, curriculum, setCookies, setHistory) => {
		// Array to display selections
		let text = []
		if (optionsJson.residency[residency][selfIdLevel]) text.push(optionsJson.residency[residency][selfIdLevel] )
		if (selfIdLevel === 'UG' && optionsJson.curriculum[curriculum].text) text.push(optionsJson.curriculum[curriculum].text)
		programDetails.querySelector('#program-wizard-values').textContent = text.join(' ')
		// Hide the form
		programWizard.classList.add('d-none')

		// Show the results
		programDetails.classList.remove('d-none')

		// The page is reusing the same title, but you cannot have two of the same ID on the page
		// so remove it when the content is hidden.    Also, only do this on program pages that
		// have yet to convert over to this new format.   Current pages have 2 unique titles.
		//
		// TODO:  Test that this can be removed now.
		if (programWizard.querySelector('h2').id == 'ipn-program-details') {
			programWizard.querySelector('h2').id = ''
			programDetails.querySelector('h2').id = 'ipn-program-details'
		}


		// Get the tuition data
		if (hasTuition) {
			fetchTuition(selfIdLevel, residency, selfIdOptions.tuitionProgram)
		}

		// Get the codes based on their selects
		let selfId = []
		if (selfIdLevel === 'UG') {
			// Get undergrad codes
			selfId = getGroups(residency,level, school, curriculum)
			// console.log(selfId);
		} else {
			// Set grad codes
			selfId = ['all']
			if (residency == 'D') {
				selfId.push('canadian')
				selfId.push('canadian-content')
			} else if (residency == 'I') {
				selfId.push('international')
				selfId.push('international-content')
			}
		}

		// Loop thru all the result sections and display the content based on groups
		programResults.forEach(async (result) => {

			// Get content element and set vars
			const content = result.querySelector('.js-self-id-content'),
				  type = content.dataset.content
			let additional = null

			// Hide each result section by default
			result.classList.add('d-none')

			// special exception
			if (type === 'applicationDeadlines' && level === 'HG') { 
				if (school === 'HD') {
					additional = 'tr-dom-all';
				} else if (school === 'HI') {
					additional = 'tr-int-all';
				}
			}

			// loop thru section options and see if any match the self-id codes
			for (const option of selfIdOptions[type]) {
				// Option not in self-id codes, bail
				if (!selfId.includes(option[0]) || !additional === option[0]) {
					continue
				}

				// Is the content option displaying content or loading it
				if (option[0].includes('-content')) {
					// Get content element
					const contentEl = result.querySelector(option[1])
					if (contentEl) {
						// Show content element
						contentEl.classList.remove('d-none')
					} else {
						// No element, bail
						continue
					}
				} else {
					// Load the matching content for the option
					const response = await fetch(option[1])

					// html didn't load, bail
					if (response.status !== 200) {
						continue
					}

					// Get the html
					const optionHtml = await response.text()
					
					// Add it to the page
					content.innerHTML = optionHtml
				}
				
				// Show the section and update all sections and in-page nav
				result.classList.remove('d-none')
				sectionStriping()
				inPageNavigation()
			}
		})

		// Update the sections and in-page nav
		sectionStriping()
		inPageNavigation()

		// Cookies and history from selection
		const formData = new FormData(selfIdForm)
		const formDataString = new URLSearchParams(formData).toString()
		if (setCookies) Cookies.set(selfIdCookieName, formDataString, { expires: 99, secure: true  })
		if (setHistory) history.pushState({}, "", "?" + formDataString)
	}

	// Behaviour specific to level
	if (selfIdLevel === 'UG') {		
		// Undergrad form behaviour
		// Get form elements
		const residencySelect = selfIdForm.querySelector('.residency-select')
		const levelSelect = selfIdForm.querySelector('.level-select')
		const schoolSelects = selfIdForm.querySelectorAll('.school-select')
		const curricSelects = selfIdForm.querySelectorAll('.curriculum-select')
		// level change behaviour
		levelSelect.addEventListener('change', () => {
			// Get the selected level
			const level = levelSelect.value
			// Loop thru school select, enabling the correct one, hiding the other
			schoolSelects.forEach((school) => {
				// get matching label
				const label = selfIdForm.querySelector(`label[for="${school.id}"]`)
				// Match school to the level
				if (school.className.includes(level)) {
					// Show school select and label
					school.disabled = false
					school.classList.remove('d-none')
					label.classList.remove('d-none')
					// Show the relevant curriculum
					curricUpdate(school.value)
				} else {
					// Hide school select and label
					school.disabled = true
					school.classList.add('d-none')
					label.classList.add('d-none')
				}
			})
		})
		// school change behaviour
		schoolSelects.forEach((schoolSelect) => {
			schoolSelect.addEventListener('change', () => {
				// Show the relevant curriculum
				curricUpdate(schoolSelect.value)
			})
		})
		// Update the curriculum selects, called when level or school changes
		const curricUpdate = (school) => {
			// Loop thru curriculum selects, enabling the correct one, hiding the others
			curricSelects.forEach((curricSelect) => {
				// Get the matching label
				const label = selfIdForm.querySelector(`label[for="${curricSelect.id}"]`)
				// Match the curriculum to the school
				if (curricSelect.id.includes(school)) {
					// Show the curriculum select and label
					curricSelect.disabled = false
					curricSelect.classList.remove('d-none')
					label.classList.remove('d-none')
				} else {
					// Hide the curriculum select and label
					curricSelect.disabled = true
					curricSelect.classList.add('d-none')
					label.classList.add('d-none')					
				}
			})
		}
		// Self-ID form submission
		selfIdForm.addEventListener('submit', (e) => {
			e.preventDefault()
			const residency = residencySelect.value,
				  level = levelSelect.value,
				  school = selfIdForm.querySelector('.school-select:not(.d-none)').value,
				  curriculum = selfIdForm.querySelector('.curriculum-select:not(.d-none)').value
			// Hide the form, show the results
			programDetailsShow(residency, level, school, curriculum, true, true)
		})
	} else {
		// Grad form behaviour
		// Get form elements
		const residencySelect = selfIdForm.querySelector('.residency-select')
		// Self-ID form submission
		selfIdForm.addEventListener('submit', (e) => {
			e.preventDefault()
			const residency = residencySelect.value
			// Hide the form, show the results
			programDetailsShow(residency, null, null, null, true, true)
		})
		
	}
	
	// Load previous selections from cookie
	const selfIdCookie = Cookies.get(selfIdCookieName)
	// Is there a cookie value or params in the URL
	if ((window.location.search && window.location.search !== '?') || selfIdCookie) {
		// pull data from cookie or URL params
		const previousData = (window.location.search && window.location.search !== '?') ? parseSelfId(window.location.search) : parseSelfId(selfIdCookie);
		// console.log(previousData);
		// show wizard results
		programDetailsShow(previousData[0], previousData[1], previousData[2], previousData[3]);
	}

	// Change back from details to form
	programReset.addEventListener('click', () => {
		// Hide the results
		programDetails.classList.add('d-none')
		resetElements.forEach(el => {if (el) el.classList.add('d-none')})
		
		// Show the form
		programWizard.classList.remove('d-none')

		// The page is reusing the same title, but you cannot have two of the same ID on the page
		// so remove it when the content is hidden.    Also, only do this on program pages that
		// have yet to convert over to this new format.   Current pages have 2 unique titles.
		if (programDetails.querySelector('h2').id == 'ipn-program-details') {
			programWizard.querySelector('h2').id = 'ipn-program-details'
			programDetails.querySelector('h2').id = ''
		}

		// Wipe the cookie
		Cookies.remove(selfIdCookieName)

		// Update the sections and in-page nav
		sectionStriping()
		inPageNavigation()
	})
}

/* toggle between collapsed and expanded <spans> */
const collapseElements = document.querySelectorAll('[data-bs-toggle="collapse"]');
collapseElements.forEach(element => {
  element.addEventListener('click', () => {
    const row = element.closest('.row')
	if (row) {
		const collapsedSpans = row.querySelectorAll('span.collapsed');
		const expandedSpans = row.querySelectorAll('span.expanded');

		collapsedSpans.forEach(span => {
		span.style.display = (span.style.display === 'none') ? 'inline' : 'none';
		});

		expandedSpans.forEach(span => {
		span.style.display = (span.style.display === 'none') ? 'inline' : 'none';
		});
  	}
  });
});

